import { RouteN } from '@/trust-admin-app/constants/router-name';
import router from '@/trust-admin-app/router';
import { Vue } from 'vue-class-component';
import { Options, Prop } from 'vue-property-decorator';

@Options({})
export default class ApplicationMenuComponent extends Vue {

  @Prop({required: true})
  public show!: boolean;

  logout(): void {
    router.push({ name: RouteN.TA.LogoutPage.n});
  }

}
